import React, { Component, useContext } from 'react'

import { Button } from '../../../index'
import { PriceTypes, TranslationComponent } from '../../../../utils'
import {
  PricingContext,
  useCartActions,
  useCartContent,
  useFeatureFlags,
} from '../../../../utils/providers'
import { trackAddToCart } from '../../../../utils/Alphapet/tracking'

class AddToCartImpl extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoading: false,
    }
  }

  addToCartAction = async (e) => {
    e.preventDefault()
    const {
      cartActions,
      productData,
      trackingData,
      selectedOptions,
      qty,
      customCouponingContext,
      pricingContext,
      isFeatureEnabled,
    } = this.props
    this.setState({ isLoading: true })

    try {
      const isAboEnabled =
        isFeatureEnabled('abo') &&
        pricingContext.priceType === PriceTypes.PRICE_ABO
      const ret = await cartActions.addItem({
        productData,
        qty,
        selectedOptions,
        isAboEnabled,
        couponCode: customCouponingContext?.addToCartCoupon,
        trackingData,
      })
      if (ret.status === 'ok') {
        this.trackAddedProduct()
      }
    } catch (error) {
      console.error(error)
    }
    this.setState({ isLoading: false })
  }

  trackAddedProduct = () => {
    const { productData, qty, pricingContext, cartContent, trackingData } =
      this.props
    const { items: allCartItems, totals, quoteIdHash } = cartContent
    const grandTotal = totals?.find((t) => t.code === 'grand_total')?.value
    const specialPrice = pricingContext.specialPrice

    trackAddToCart({
      productData,
      qty,
      cartTotals: grandTotal,
      cartItems: allCartItems,
      specialPrice,
      trackingData,
      quoteIdHash,
    })
  }

  render() {
    const { className = null, text = null, variant = 'primary' } = this.props
    const { isLoading } = this.state

    const btnText = text ? (
      text
    ) : (
      <TranslationComponent text="PRODUCT_TILE_ADD_TO_CART" />
    )
    return (
      <Button
        variant={variant}
        className={className}
        onClick={this.addToCartAction}
        isLoading={isLoading}
        data-testid="btn-add-to-cart"
      >
        {btnText}
      </Button>
    )
  }
}

export default function AddToCartButton(props) {
  const { pricingContext, customCouponingContext } =
    useContext(PricingContext) || {}
  const cartContent = useCartContent()
  const cartActions = useCartActions()
  const { isFeatureEnabled } = useFeatureFlags()
  return (
    <AddToCartImpl
      cartActions={cartActions}
      cartContent={cartContent}
      isFeatureEnabled={isFeatureEnabled}
      pricingContext={pricingContext}
      customCouponingContext={customCouponingContext}
      {...props}
    />
  )
}
